import { ColumnsType } from "antd/es/table";
import { Link } from "react-router-dom";
import { EyeOutlined } from "@ant-design/icons";
import { Button } from "@rumbledirect/ui";

export const imageCaptureAccountColumns: ColumnsType<any> = [
  {
    title: "Titel",
    dataIndex: "title",
    key: "title",
    render: (text: string, record: any) => (
      <Link to={`/image-captures/accounts/${record.id}`}>{text}</Link>
    ),
  },
  {
    title: "Client ID",
    dataIndex: "clientId",
    key: "clientId",
  },
  {
    title: "Stage",
    dataIndex: "stage",
    key: "stage",
  },
  {
    title: "Acties",
    key: "actions",
    render: (_: any, record) => (
      <Link to={`/image-captures/accounts/${record.id}`}>
        <Button icon={<EyeOutlined />} variant="light" />
      </Link>
    ),
  },
];
